/**
 * @hidden
 */
export function replaceWindowHistoryState(title: string, url: string) {
  window.history.replaceState(history.state, title, url);
}
